import React from "react"
import { translation } from "../../../helper/translation"
import audiosyncLogo from "../../../assets/images/project-images/audiosync-logo.png"
import ekaplayerLogo from "../../../assets/images/project-images/ekaiptv-logo.png"
import ekatimeLogo from "../../../assets/images/project-images/ekatime-logo.png"
import ekamatchLogo from "../../../assets/images/project-images/ekamatch-logo.png"
import trainalysisLogo from "../../../assets/images/project-images/trainalysis-logo.png"
import digitalsignageLogo from "../../../assets/images/companies/best_systems_logo.png"
import virtualtourLogo from "../../../assets/images/project-images/virtualtour-logo.svg"

type ProjectEntry = {
    key: string
    image?: string
    icon?: string
    imageClass?: string
}

const projectEntries: ProjectEntry[] = [
    { key: "audiosync", image: audiosyncLogo, imageClass: "project-card__logo--compact" },
    { key: "trainalysis", image: trainalysisLogo, imageClass: "project-card__logo--compact project-card__logo--dark" },
    { key: "ekaplayer", image: ekaplayerLogo },
    { key: "ekamatch", image: ekamatchLogo, imageClass: "project-card__logo--compact" },
    { key: "ekatime", image: ekatimeLogo },
    //{ key: "digitalsignage", image: digitalsignageLogo, imageClass: "project-card__logo--compact" },
    { key: "virtualtour", image: virtualtourLogo, imageClass: "project-card__logo--compact project-card__logo--dark" },
]

export const ContentProjectsPageProjects = () => {
    return (
        <div className="contest-details projects-page">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="top-content">
                            <span className="open">{translation("projects")}</span>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="main-content projects">
                            <div className="projects-page__intro">
                                <h4>{translation("projects")}</h4>
                                <h6>{translation("projects-head-title")}</h6>
                                <p className="projects-page__intro-text">{translation("projects-intro")}</p>
                            </div>

                            <div className="projects-grid">
                                {projectEntries.map((project) => {
                                    const techList = translation(`${project.key}.technologies`).split(",").map((tech) => tech.trim())

                                    return (
                                        <article className="project-card" key={project.key}>
                                            <div className="project-card__header">
                                                <div className={`project-card__logo ${project.imageClass ?? ""}`}>
                                                    {project.image ? (
                                                        <img src={project.image} alt={translation(`${project.key}.title`)} />
                                                    ) : (
                                                        <i className={`fa ${project.icon}`} aria-hidden="true"></i>
                                                    )}
                                                </div>
                                                <span className="project-card__year">{translation(`${project.key}.year`)}</span>
                                            </div>

                                            <div className="project-card__body">
                                                <h5 className="project-card__title">{translation(`${project.key}.title`)}</h5>
                                                <p className="project-card__description">{translation(`${project.key}.description`)}</p>

                                                <div className="project-card__meta">
                                                    <div className="project-card__meta-item">
                                                        <span className="project-card__meta-label">{translation("projects-role")}</span>
                                                        <span className="project-card__meta-value">{translation(`${project.key}.role`)}</span>
                                                    </div>
                                                </div>

                                                <div className="project-card__tech">
                                                    {techList.map((tech) => (
                                                        <span className="project-card__tech-tag" key={tech}>{tech}</span>
                                                    ))}
                                                </div>
                                            </div>
                                        </article>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
